export default __webpack_public_path__ + "static/media/BusinessConsultingLebenswerkBusinessManagement3.56167619.png";